import React, { useEffect, useState } from "react";
export default function TravelSendMessage({ setMessage, message, sendAfterEnter, send, uploadFile }) {

  return (
    <>
      <textarea
        value={message}
        style={{ flex: 1 }}
        maxLength={1024}
        // placeholder={disableInput ? "Please select an option... " : "Send a message..."}
        placeholder={"Type your query..."}
        label=""
        // disabled={disableInput}
        required
        onChange={(event) => setMessage(event.currentTarget.value)}
        onKeyDown={(e) => sendAfterEnter(e)}
      />
      {/* <label className="fileInput">
        <input type={'file'} onChange={(event) => uploadFile(event.target.files)}></input>
      </label> */}
      <button className="SendMsgbutton" onClick={send}>Send</button>
    </>
  );
}
